import { FC } from 'react';
import { Container } from './components';

interface RefusedProps {
  interview?: any;
}

const Refused: FC<RefusedProps> = ({ interview }) => {
  // Comparaison stricte des IDs
  const isAuthor = String(interview?.authorId) === String(interview?.mentorship?.mentorId);

  return (
    <Container>
      <p>
        {isAuthor 
          ? "Le mentoré a refusé votre proposition d'entretien." 
          : "Vous avez refusé la proposition d'entretien."}
      </p>
    </Container>
  );
};

export default Refused;